<p *ngIf="loading">Loading...</p>
<nz-table *ngIf="!loading"
	[nzBordered]="true"
	[nzData]="policies"
	[nzFrontPagination]="false"
	[nzShowPagination]="false">
	<thead>
		<tr>
			<th>Policy Number</th>
			<th>Product</th>
			<th>Offer</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let policy of policies; let i = index" class="cursor-pointer" (dblclick)="openPolicy(policy)">
			<td>{{ policy.policyNumber }}</td>
			<td>{{ policy.product!.name }}</td>
			<td>{{ policy.productOffer!.name }}</td>
		</tr>
	</tbody>
</nz-table>
